"use client";

import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

import enCommonTranslations from "./trad/en/common.json";
import enGlossaryTranslations from "./trad/en/glossary.json";
import enValidationTranslations from "./trad/en/validation.json";
import frCommonTranslations from "./trad/fr/common.json";
import frGlossaryTranslations from "./trad/fr/glossary.json";
import frValidationTranslations from "./trad/fr/validation.json";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    lng: "fr",
    fallbackLng: "fr",
    preload: ["fr", "en"],
    ns: ["common", "validation", "glossary"],
    defaultNS: "glossary",
    resources: {
      fr: {
        common: frCommonTranslations,
        validation: frValidationTranslations,
        glossary: frGlossaryTranslations,
      },
      en: {
        common: enCommonTranslations,
        validation: enValidationTranslations,
        glossary: enGlossaryTranslations,
      },
    },
    initImmediate: false,
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
